module.exports = __webpack_public_path__ + "img/confidential.08b5f12d.svg";